/*
 * Copyright (c) 2023 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import { fields, factoryT } from 'factory-t';
import {
    DelayedDownloadingStatus,
    DelayedDownloadingType,
    DelayedDownloadingsListItemDto,
    LazyLoadingErrorTypes,
} from './downloadingsClient.typings';

export const delayedDownloadingListItemFactory = factoryT<DelayedDownloadingsListItemDto>({
    type: fields.sequence(Object.values(DelayedDownloadingType)),
    name: (ctx) => 'unique_file_name_' + ctx.index.toString(),
    id: (ctx) => 55 + ctx.index,
    requestedDateAtUtc: '2020-02-02T11:27:11.996063',
    status: fields.sequence([DelayedDownloadingStatus.Ready, DelayedDownloadingStatus.Error]),
    errorMessage: fields.sequence([null, LazyLoadingErrorTypes.MAX_ROWS_COUNT]),
});
